import { axiosInstance } from '../clients/axiosClient';
import { API_V1_PREFIX } from '../utils/constants';

export interface CreateAdminRequest {
    email: string;
    first_name: string;
    last_name: string;
    team_id?: string | null;
}

export const createAdmin = async (
    payload: CreateAdminRequest
): Promise<any> => {
    try {
        const { data } = await axiosInstance.post(
            `${API_V1_PREFIX}superadmin/create/admin`,
            payload
        );

        return data;
    } catch (error: any) {
        throw new Error(error.response?.data?.detail || error.response?.data?.message || error.message || 'Failed to create admin');
    }
};
export interface AdminMember {
    id: string | number;
    email: string;
    first_name: string;
    last_name: string;
    role: string;
    is_active: boolean;
    phone?: string;
    team_id?: string;
    team_name?: string;
}

export interface AdminsListResponse {
    admins: AdminMember[];
    'total count': number;
}

export const getAdminsList = async (
    limit: number = 10,
    offset: number = 0
): Promise<AdminsListResponse> => {
    try {
        const params = new URLSearchParams({
            limit: limit.toString(),
            offset: offset.toString(),
        });

        const { data } = await axiosInstance.get(
            `${API_V1_PREFIX}superadmin/admins/list?${params.toString()}`
        );

        return data;
    } catch (error: any) {
        throw new Error(error.response?.data?.detail || error.response?.data?.message || error.message || 'Failed to fetch admins list');
    }
};

export const getAdminById = async (adminId: string | number): Promise<AdminMember> => {
    try {
        const { data } = await axiosInstance.get(
            `${API_V1_PREFIX}superadmin/admins/${adminId}`
        );

        return data;
    } catch (error: any) {
        throw new Error(error.response?.data?.detail || error.response?.data?.message || error.message || 'Failed to fetch admin details');
    }
};

export interface UpdateAdminRequest {
    email?: string;
    first_name?: string;
    last_name?: string;
    team_id?: string | null;
}

export const updateAdmin = async (
    adminId: string | number,
    payload: UpdateAdminRequest
): Promise<any> => {
    try {
        const { data } = await axiosInstance.patch(
            `${API_V1_PREFIX}superadmin/admins/update/${adminId}`,
            payload
        );

        return data;
    } catch (error: any) {
        throw new Error(error.response?.data?.detail || error.response?.data?.message || error.message || 'Failed to update admin');
    }
};

export const updateAdminStatus = async (
    adminId: string | number,
    is_active: boolean
): Promise<any> => {
    try {
        const { data } = await axiosInstance.patch(
            `${API_V1_PREFIX}superadmin/admins/${adminId}/status`,
            { is_active }
        );

        return data;
    } catch (error: any) {
        throw new Error(error.response?.data?.detail || error.response?.data?.message || error.message || 'Failed to update admin status');
    }
};
